import Seo from "@/lib/Seo";
import { PageHead } from "@/pages/About";

const PROFILE_URL = "https://drive.google.com/file/d/1weYjkhF4TQALmDj-sVXX93nJw_WsyIuE/view?usp=sharing";

export default function Profile() {
  return <>
    <Seo path="/profile" title="الملف التعريفي" description="معاينة الملف التعريفي الكامل لسياق." />
    <PageHead eyebrow="الملف التعريفي" title="تعرّف على سياق" subtitle="اطّلع على الملف التعريفي الكامل، مشاريعنا، عملائنا وإنجازاتنا" />
    <section className="bg-paper py-12 sm:py-16">
      <div className="mx-auto max-w-[1200px] px-6 sm:px-10">
        <div className="flex justify-start mb-5">
          <a href={PROFILE_URL} target="_blank" rel="noreferrer" className="bg-coral text-white px-6 py-3">فتح أو تنزيل الملف</a>
        </div>
        <iframe title="الملف التعريفي الكامل لسياق" src="https://drive.google.com/file/d/1weYjkhF4TQALmDj-sVXX93nJw_WsyIuE/preview" className="w-full bg-white border border-navy/10" style={{height:"min(80vh,820px)"}} allow="autoplay" />
      </div>
    </section>
  </>;
}
